import _Array$isArray from "../../core-js/array/is-array";
export default function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}


//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/node_modules/@babel/runtime-corejs3/helpers/esm/arrayWithHoles.js
// module id = 1406
// module chunks = 44